import React from 'react'
import PropTypes from 'prop-types'
import { AddAddendumForm } from '../forms'
import { useHistory } from 'react-router-dom'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors } from '../reducer'
import * as actions from '../actions'
import { isNotificationsAddonEnabled } from 'config/portal'

const propTypes = {
  setAddAddendum: PropTypes.func,
  addAddendum: PropTypes.string,
  setAddNotificationsAddendum: PropTypes.func,
  addNotificationsAddendum: PropTypes.string,
}

function AddAddendumView({
  setAddAddendum,
  addAddendum,
  setAddNotificationsAddendum,
  addNotificationsAddendum,
}) {
  const history = useHistory()

  return (
    <div className="card full-height">
      {isNotificationsAddonEnabled() ? (
        <div className="form-masthead">
          <h2>
            Would you like to add any additional products to your agreement?
          </h2>
        </div>
      ) : (
        <div className="form-masthead">
          <h2>Add a benefit distributions addendum</h2>
        </div>
      )}
      <div className="add-addendum-form">
        <AddAddendumForm
          initialValues={{
            addAddendum: addAddendum || '',
            addNotificationsAddendum: addNotificationsAddendum || '',
          }}
          onSubmit={({ addAddendum, addNotificationsAddendum }) => {
            setAddAddendum(addAddendum)
            setAddNotificationsAddendum(addNotificationsAddendum)
            history.push({
              pathname: '/automatic-rollovers/complete-services-agreement',
              state: {
                search: history.location.state?.search,
              },
            })
          }}
        />
      </div>
    </div>
  )
}

AddAddendumView.propTypes = propTypes

function mapStateToProps(state) {
  return {
    addAddendum: selectors.addAddendum(state),
    addNotificationsAddendum: selectors.addNotificationsAddendum(state),
  }
}

const mapDispatchToProps = {
  setAddAddendum: actions.setAddAddendum,
  setAddNotificationsAddendum: actions.setAddNotificationsAddAddendum,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AddAddendumView
)
